import { createBrowserRouter, RouterProvider, Navigate, Outlet, redirect } from 'react-router-dom';
import { tokenStorage } from '@/user/api';
import Home from '@/user/Home';
import Login from '@/user/Login';
import Register from '@/user/Register';
import Articles from '@/user/Articles';
import ArticleDetail from '@/user/ArticleDetail/ArticleDetail';
import Marketing from '@/user/Marketing';
import MarketingDetail from '@/user/MarketingDetail';
import Resources from '@/user/Resources';
import Distribution from '@/user/Distribution';
import Investment from '@/user/Investment';
import Shop from '@/user/Shop';
import ProductDetail from '@/user/ProductDetail';
import Cart from '@/user/Cart';
import Checkout from '@/user/Checkout';
import About from '@/user/About';
import PingAn from '@/user/XinjiangPingAn';
import ConsoleLayout from '@/user/console/ConsoleLayout';
import ProfilePage from '@/user/console/ProfilePage';
import ProductsPage from '@/user/console/ProductsPage';
import OrdersPage from '@/user/console/OrdersPage';
import PrivacyPolicy from '@/user/policyService/PrivacyPolicy';
import ServiceAgreement from '@/user/policyService/serviceAgreetment';
import ECardManageIndex from '@/user/console/eCardManage/index';
import DepartmentManage from '@/user/console/eCardManage/DepartmentManage';
import HomepageConfiguration from '@/user/console/eCardManage/HomepageConfiguration';  
import MicrOfficialWebsite from '@/user/console/eCardManage/micrOfficialWebsite';
import EmployeeManage from '@/user/console/eCardManage/EmployeeManage';
import ThemeConfiguration from '@/user/console/eCardManage/ThemeConfiguration';
import ElectronicBusinessCards from '@/user/console/eCardManage/ElectronicBusinessCards';
// Admin imports
import AdminLayout from '@/admin/layouts/AdminLayout';
import AdminLogin from '@/admin/pages/Login';
import Dashboard from '@/admin/pages/Dashboard';
import UserManage from '@/admin/pages/system/UserManage';
import RoleManage from '@/admin/pages/system/RoleManage';
import MenuManage from '@/admin/pages/system/MenuManage';
import VisitLogManage from '@/admin/pages/system/VisitLogManage';
import BannerManage from '@/admin/pages/system/bannerManage';
import ArticleManage from '@/admin/pages/business/ArticleManage';
import SupplierManage from '@/admin/pages/business/SupplierManage';
import BuyerManage from '@/admin/pages/business/BuyerManage';
import ProductAudit from '@/admin/pages/business/ProductAudit';
import OrderAudit from '@/admin/pages/business/OrderAudit';
import MarketingManage from '@/admin/pages/business/MarketingManage';
import FeePaymentManage from '@/admin/pages/business/FeePaymentManage';
import ProductIntroManage from '@/admin/pages/business/ProductIntroManage';
import EcardManage from '@/admin/pages/business/EcardManage';
import DictManage from '@/admin/pages/system/DictManage';
import SupplierPlatform from '@/admin/pages/Supplier/SupplierPlatform';


// ===================== 路由守卫（使用 loader，避免渲染时跳转循环）=====================

// 后台路由守卫 - 需要管理员登录
const requireAdminAuth = () => {
  const isLoggedIn = tokenStorage.isAdminLoggedIn();
  if (!isLoggedIn) {
    return redirect('/admin/login');
  }
  return null;
};

// 后台登录页面守卫 - 已登录则跳转
const requireAdminGuest = () => {
  const isLoggedIn = tokenStorage.isAdminLoggedIn();
  console.log('requireAdminGuest:', isLoggedIn, tokenStorage.getToken());
  if (isLoggedIn) {
    return redirect('/admin');
  }
  return null;
};

// ===================== 路由配置 =====================

const router = createBrowserRouter([
  // ========== 前台路由 ==========
  { path: '/', element: <Home /> },
  { path: '/login', element: <Login /> },
  { path: '/register', element: <Register /> },
  { path: '/articles', element: <Articles /> },
  { path: '/article/:id', element: <ArticleDetail /> },
  { path: '/marketing', element: <Marketing /> },
  { path: '/marketing/:id', element: <MarketingDetail /> },
  { path: '/resources', element: <Resources /> },
  { path: '/distribution', element: <Distribution /> },
  { path: '/investment', element: <Investment /> },
  { path: '/shop', element: <Shop /> },
  { path: '/shop/product/:id', element: <ProductDetail /> },
  { path: '/cart', element: <Cart /> },
  { path: '/checkout', element: <Checkout /> },
  { path: '/about', element: <About /> },
  { path: '/pingan', element: <PingAn /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/service-agreement', element: <ServiceAgreement /> },
  // ========== 用户控制台 ==========
  {
    path: '/console',
    element: <ConsoleLayout />,
    children: [
      { index: true, element: <Navigate to="/console/profile" replace /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'products', element: <ProductsPage /> },
      { path: 'orders', element: <OrdersPage /> },
      // 电子名片管理
      { path: 'ecardManage/department', element: <DepartmentManage /> },
      { path: 'ecardManage/index', element: <ECardManageIndex /> },
      { path: 'ecardManage/homepage', element: <HomepageConfiguration /> },
      { path: 'ecardManage/micrOfficialWebsite', element: <MicrOfficialWebsite /> },
      { path: 'ecardManage/employee', element: <EmployeeManage /> },
      { path: 'ecardManage/theme', element: <ThemeConfiguration /> },
      { path: 'ecardManage/electronicBusinessCards', element: <ElectronicBusinessCards /> },
    ],
  },

  // ========== 后台登录页 ==========
  {
    path: '/admin/login',
    element: <AdminLogin />,
    loader: requireAdminGuest, // 已登录则跳走
  },

  // ========== 后台管理路由 ==========
  {
    path: '/admin',
    loader: requireAdminAuth, // 未登录则跳走
    element: <AdminLayout />, // 直接用 AdminLayout 作为布局
    children: [
      { index: true, element: <Dashboard /> },
      // 系统管理
      { path: 'system/user', element: <UserManage /> },
      { path: 'system/role', element: <RoleManage /> },
      { path: 'system/menu', element: <MenuManage /> },
      { path: 'system/visit-log', element: <VisitLogManage /> },
      { path: 'system/banner', element: <BannerManage /> },
      { path: 'system/dict', element: <DictManage /> },
      // 业务管理
      { path: 'business/article', element: <ArticleManage /> },
      { path: 'business/marketing', element: <MarketingManage /> },
      { path: 'business/order', element: <OrderAudit /> },
      { path: 'business/fee-payment', element: <FeePaymentManage /> },
      // 商城业务（新旧路由兼容）
      { path: 'mall/product', element: <ProductAudit /> },
      { path: 'mall/order-audit', element: <OrderAudit /> },
      { path: 'mall/supplier', element: <SupplierManage /> },
      { path: 'mall/buyer', element: <BuyerManage /> },
      { path: 'mall/fee-payment', element: <FeePaymentManage /> },
      // 旧路由兼容（business 前缀仍可访问）
      { path: 'business/product', element: <ProductAudit /> },
      { path: 'business/order-audit', element: <OrderAudit /> },
      { path: 'business/supplier', element: <SupplierManage /> },
      { path: 'business/buyer', element: <BuyerManage /> },
      { path: 'business/product-intro', element: <ProductIntroManage /> },
      { path: 'business/ecard', element: <EcardManage /> },
      // 供应商管理
      { path: 'supplier/platform', element: <SupplierPlatform /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
